import { createVueDaumPostcode } from './create-vue-daum-postcode'

export default createVueDaumPostcode()
